// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	firebase_path_prefix: 'dev_',
	baseUrl: 'https://devmage.entrelabel.com',
	store_url: 'entrelable',
	stroreBaseUrl: 'https://entrelabel.com',
	social_login: {
		google_id: '441971591905-cnj94moro8f9euqiq3rnmr5fk43dr72t.apps.googleusercontent.com',
		facebook_id: '691524414945969'
	},
	use_voucher: true,
	fb_pixel: {
		events: {
			purchase: false /** only enabled in prod */
		}
	},
	contact: {
		receiver: 'hnddev7@entrelabel.com'
	},
	socket_url: 'https://mage.entrelabel.com:25594',
	google_maps_key: 'AIzaSyBrQR1XLr1BtX_6Z1flQ6ZWHIKiCCYkwtg' /** 'AIzaSyAduafcSGDO4HjZ-1taw3m19N6EEef9L3w' */
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
